import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'bootstrap-panel',
  props: {
    title: { type: [String, Boolean] },
    titleType: null,
    footer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    title?: string | boolean;
    //h1 is centered, div is not, default is h1
    titleType?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    footer?: boolean;
}



return { __sfc: true,props }
}

})